import React from "react";
import Modal from "react-modal";
const { Scanner } = require("@yudiel/react-qr-scanner/dist/index.cjs"); // see note below

function CheckInScannerModal({ isOpen, onClose, onSubmit }) {
  if (!isOpen) return null;

  const handleScan = (results) => {
    if (results.length > 0) {
      const scannedText = results[0].rawValue;
      onSubmit(scannedText);
    }
  };

  return (
    <Modal isOpen={true} className="modal-container">
      <div className="card small-modal">
        <p className="large-text mb-8">Scan QR Code</p>
        <p className="accent-text fs-14 mb-16">
          Scan the attendee's QR code to search.
        </p>
        <Scanner
          onScan={handleScan}
          onError={(err) => console.error(err)}
          sound={false}
        />
        <div className="modal-btns">
          <button
            className="btn link-text-secondary uppercase-text"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default CheckInScannerModal;

/**
 * NOTE: @yudiel/react-qr-scanner currently produces a React warning upon modal unmount:
 *   "Can't perform a React state update on an unmounted component."
 *
 * Cause:
 * - The Scanner component keeps an internal `requestAnimationFrame` loop
 *   and tries to update its internal state after the parent is unmounted.
 *
 * Why it's safe:
 * - It does NOT break functionality or cause memory leaks in practice.
 * - The scanner stops using the camera when unmounted (media tracks are closed).
 * - The warning is from the library internals and outside our control.
 *
 * Why we still use this library:
 * - Actively maintained and modern (supports `BarcodeDetector` + WebAssembly).
 * - Much more reliable and up-to-date than older libs (e.g. react-qr-reader).
 * - Supports both camera-based scanning and hardware scanner fallback.
 *
 * Future plan:
 * - Track the GitHub issue and upgrade if/when the library fixes it.
 * - If a breaking issue appears, we can swap to a manual implementation.
 *
 * Bottom line:
 * - This warning is harmless and can be safely ignored.
 */
